export default function teacherid(state = '', action) {
  if (action.type === 'teacherid') {
    return state = action.id;
  } else {
    return state;
  }
}
